import React, { useState } from 'react';
import { connect, useIntl, useRouteMatch } from 'umi';
import { Layout, Row, Col } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import TableContext from './compontnts/TableContext';
import ClockContent from './compontnts/ClockContent';
import { useBuriedPoint } from '@/pages/home/utils/customHook';
import DailyByTimezoneFilter from '@/pages/dashboard/filterPageComponents/multiTimezone/dailyByTimezoneFilterNew';
import { FORM_MAP } from '@/pages/dashboard/pages/multiTimezone/_config/constant';
import useSelectorData from '../../filterPageComponents/multiTimezone/hooks/useSelectorData';
import { useMetrics } from './_config/utils';
import SegmentMetrics from './compontnts/SegmentMetrics';
import DAUTrendChart from './compontnts/DAUTrendChart';
import GuideCountryComparison from '@/pages/dashboard/components/UserGuide/CountryComparison';
import MarqueeInfo from '@/pages/dashboard/components/MarqueeInfo';

import '@/pages/dashboard/assets/scss/page/multiTimezone/dailyTimezone.scss';
import '@/pages/dashboard/assets/scss/page/comparison/dateComparison.scss';

const { Content } = Layout;

function DailyByTimezone(props: any) {
  const { explainInfo, gameCode } = props;
  const [isHover, setIsHover] = useState(false);
  const [filterConfirm, setFilterConfirm] = useState(false);

  const { formatMessage } = useIntl();
  const timezoneType = useRouteMatch()?.params?.timezonetype;
  const [formValue, setFormValue] = useState();
  const [filterLoading, setFilterLoading] = useState(true);
  const { options } = useMetrics();
  const [metricsValue, setMetricsValue] = useState(options[0]);
  useSelectorData();
  // 埋点
  const logObj = {
    pageId: timezoneType === 'country' ? '201801' : '202001',
    pageName: `multiTimezoneDailyByTimezone${
      timezoneType === 'country' ? 'Country' : 'Zone'
    }`,
    extInfo: `multiTimezoneDailyByTimezone${
      timezoneType === 'country' ? 'Country' : 'Zone'
    }`,
    pagePath: `/multiTimezone/dailyTimezone/${timezoneType}`,
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };

  useBuriedPoint(logObj);

  const handleConfirm = (value: any) => {
    setFormValue({
      ...formValue,
      ...value.filterValue,
      [FORM_MAP.IS_INIT]: value.rangeInit,
    });
    setFilterConfirm(true);
  };
  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value.filterValue,
    });
    setFilterLoading(false);
  };
  return (
    <Content className="dbd-daily-timezone-zone dbd-scroll-body">
      <Content.Header
        title={
          <div className="dbd-daily-timezone-zone-head">
            <div className="dbd-daily-timezone-zone-title">
              {formatMessage({ id: 'daily_by_timezone_title' })}
            </div>
            <div className="dbd-daily-timezone-zone-desc">
              <i
                className="dbd-daily-timezone-zone-icon-right"
                onMouseOver={() => {
                  setIsHover(true);
                }}
                onMouseOut={() => {
                  setIsHover(false);
                }}
              >
                <SvgIcon
                  className="select-header-ic"
                  type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
                />
              </i>
              <span>
                {formatMessage({ id: 'daily_by_timezone_sub_title' })}
              </span>
            </div>
          </div>
        }
      />

      <Content.Body full>
        <MarqueeInfo
          pagePath={`/multiTimezone/dailyTimezone/${timezoneType}`}
        />
        <Row>
          <Col span={24}>
            <ClockContent
              gameCode={gameCode}
              filterLoading={filterLoading}
              timezoneType={timezoneType}
            />
          </Col>
        </Row>

        <Row className="margin-t-10">
          <Col span={24}>
            <DailyByTimezoneFilter
              openSticky={true}
              type={timezoneType}
              filterConfirm={handleConfirm}
              filterReset={handleConfirm}
              filterInit={handleInit}
              buttonLogConfig={{
                pageId: logObj?.pageId,
                confirmButtonId: `${logObj?.pageId  }001`,
                resetButtonId: `${logObj?.pageId  }002`,
              }}
            />
          </Col>
        </Row>

        <Row >
          <Col span={24}>
            <SegmentMetrics
              value={metricsValue?.value}
              onChange={setMetricsValue}
            />
          </Col>
        </Row>

        <Row className="margin-b-10">
          <Col span={24}>
            <DAUTrendChart
              loading={filterLoading}
              gameCode={gameCode}
              formValue={formValue}
              selectMetrics={metricsValue}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <TableContext
              filterLoading={filterLoading}
              formValue={formValue}
              explainInfo={explainInfo}
              gameCode={gameCode}
              metrics={options}
              timezoneType={timezoneType}
              filterConfirm={filterConfirm}
              setFilterConfirm={setFilterConfirm}
            />
          </Col>
        </Row>
        {/* 新手引导 */}
        { timezoneType === 'country' && <GuideCountryComparison/>}
      </Content.Body>
    </Content>
  );
}

export default connect((state: any) => {
  return {
    gameCode: state.dashboard?.currentGame?.game_code,
    explainInfo: state.dashboard?.explainInfo,
  };
})(DailyByTimezone);
